exports.ByName = {
  FullValue: { Id: 0, Name: 'Full Value' },
  Hundredths: { Id: 1, Name: 'Hundredths' },
  Thousandths: { Id: 2, Name: 'Thousandths' },
  TenThousands: { Id: 3, Name: 'Ten Thousands' },
  HundredThousands: { Id: 4, Name: 'Hundred Thousands' },
  Millionths: { Id: 5, Name: 'Millionths' },
  TenMillionths: { Id: 6, Name: 'Ten Millionths' },
  HundredMillionths: { Id: 7, Name: 'Hundred Millionths' }
};

exports.ById = {
  0: { Id: 0, Name: 'Full Value' },
  1: { Id: 1, Name: 'Hundredths' },
  2: { Id: 2, Name: 'Thousandths' },
  3: { Id: 3, Name: 'Ten Thousands' },
  4: { Id: 4, Name: 'Hundred Thousands' },
  5: { Id: 5, Name: 'Millionths' },
  6: { Id: 6, Name: 'Ten Millionths' },
  7: { Id: 7, Name: 'Hundred Millionths' }
};
